export enum WeeklyForecastComponentType {
  TREND = 'trend',
  SEASONALITY = 'seasonality',
  YEARLY = 'yearly',
  SEARCH= 'search'
}

